import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { FORGOT_STATES } from './useForgotPassword.types';
import type { ForgotPasswordState } from './useForgotPassword.types';

export { FORGOT_STATES } from './useForgotPassword.types';
export type { ForgotPasswordState } from './useForgotPassword.types';

export function useForgotPassword() {
  const navigate = useNavigate();
  const { requestPasswordReset } = useAuth();
  const [currentState, setCurrentState] = useState<ForgotPasswordState>(FORGOT_STATES.DEFAULT);
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isEmailValid = email.includes('@') && email.includes('.');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!isEmailValid) return;
    setIsSubmitting(true);
    const res = await requestPasswordReset(email);
    setIsSubmitting(false);
    if (res.ok) {
      setCurrentState(FORGOT_STATES.SUCCESS);
      return;
    }
    const reason = (res as { reason?: string }).reason as
      | 'EMAIL_NOT_FOUND'
      | 'ACCOUNT_BLOCKED'
      | 'NOT_ACTIVATED'
      | 'UNKNOWN';
    if (reason === 'EMAIL_NOT_FOUND') setCurrentState(FORGOT_STATES.EMAIL_NOT_FOUND);
    else if (reason === 'ACCOUNT_BLOCKED') setCurrentState(FORGOT_STATES.ACCOUNT_BLOCKED);
    else if (reason === 'NOT_ACTIVATED') setCurrentState(FORGOT_STATES.NOT_ACTIVATED);
    else setCurrentState(FORGOT_STATES.EMAIL_NOT_FOUND);
  };

  const handleTryAgain = () => setCurrentState(FORGOT_STATES.DEFAULT);

  return {
    email,
    setEmail,
    currentState,
    setCurrentState,
    isSubmitting,
    isEmailValid,
    handleSubmit,
    handleTryAgain,
    navigate,
  };
}
